
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { useEffect } from "react"
import { useScrollLock } from "../../../hooks/useScrollLock"
import ResultSuccessTickMark from "../../shared/ResultSuccessTickMark"
import Btn from "../../shared/button/Btn"
import { useNavigate } from "react-router-dom"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 650px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            margin: 15px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 30px;
            
            
            p{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                color: ${({theme}) => theme.mainTextColor};
            }
            
        }
    }
`
const RegisterResultModal = () => {
    const dispatch = useDispatch()
    const { lockScroll, unlockScroll } = useScrollLock();
    const navigate = useNavigate()

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

  return (
    <Container>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <div className="content">
                <ResultSuccessTickMark />
                <p>Üyelik başvurunuz onay aşamasındadır. Uzmanlarımız tarafından size geri dönüş yapılacaktır. 444 6 985 numaralı telefonu arayarak bilgi alabilirsiniz.</p>
                <Btn bgColor="#E85446" color="#fff" width={"220px"} handleClick={() => navigate("/giris-yap")}>Tamam</Btn>
            </div>
        </div>
    </Container>
  )
}

export default RegisterResultModal